<template>
  <router-link v-if="to" :to="to" class="gradient-btn" :class="customClass">
    <slot>{{ label }}</slot>
  </router-link>
  <button
    v-else
    class="gradient-btn"
    :class="customClass"
    type="button"
    @click="$emit('click', $event)"
  >
    <slot>{{ label }}</slot>
  </button>
</template>

<script setup>
defineProps({
  to: { type: [String, Object], default: null },
  label: { type: String, default: '' },
  customClass: { type: [String, Array, Object], default: '' },
})
defineEmits(['click'])
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";

.gradient-btn {
  display: inline-block;
  background-image: linear-gradient(90deg, #f6d68f 0%, #89d6c3 100%);
  color: $bluFour;
  border: none;
  border-radius: 12px;
  padding: 12px 18px;
  min-width: 160px;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  font-family: OpenSansRegular;
  font-size: $font14;
}
</style>
